// Political district titles keyed by admunit id (AT.305 = Bezirk Amstetten).
// Municipality GKZ AT.31235 belongs to district AT.312.
export const POLITICAL_DISTRICT_BY_ADMUNIT_ID: Record<string, string> = {
  'AT.101': 'Eisenstadt',
  'AT.102': 'Rust',
  'AT.103': 'Eisenstadt-Umgebung',
  'AT.104': 'Güssing',
  'AT.105': 'Jennersdorf',
  'AT.106': 'Mattersburg',
  'AT.107': 'Neusiedl am See',
  'AT.108': 'Oberpullendorf',
  'AT.109': 'Oberwart',
  'AT.201': 'Klagenfurt',
  'AT.202': 'Villach',
  'AT.203': 'Hermagor',
  'AT.204': 'Klagenfurt Land',
  'AT.205': 'St. Veit an der Glan',
  'AT.206': 'Spittal an der Drau',
  'AT.207': 'Villach Land',
  'AT.208': 'Völkermarkt',
  'AT.209': 'Wolfsberg',
  'AT.210': 'Feldkirchen',
  'AT.301': 'Krems an der Donau',
  'AT.302': 'St. Pölten',
  'AT.303': 'Waidhofen an der Ybbs',
  'AT.304': 'Wiener Neustadt',
  'AT.305': 'Amstetten',
  'AT.306': 'Baden',
  'AT.307': 'Bruck an der Leitha',
  'AT.308': 'Gänserndorf',
  'AT.309': 'Gmünd',
  'AT.310': 'Hollabrunn',
  'AT.311': 'Horn',
  'AT.312': 'Korneuburg',
  'AT.313': 'Krems',
  'AT.314': 'Lilienfeld',
  'AT.315': 'Melk',
  'AT.316': 'Mistelbach',
  'AT.317': 'Mödling',
  'AT.318': 'Neunkirchen',
  'AT.319': 'St. Pölten Land',
  'AT.320': 'Scheibbs',
  'AT.321': 'Tulln',
  'AT.322': 'Waidhofen an der Thaya',
  'AT.323': 'Wiener Neustadt Land',
  'AT.324': 'Wien-Umgebung',
  'AT.325': 'Zwettl',
  'AT.401': 'Linz',
  'AT.402': 'Steyr',
  'AT.403': 'Wels',
  'AT.404': 'Braunau am Inn',
  'AT.405': 'Eferding',
  'AT.406': 'Freistadt',
  'AT.407': 'Gmunden',
  'AT.408': 'Grieskirchen',
  'AT.409': 'Kirchdorf an der Krems',
  'AT.410': 'Linz-Land',
  'AT.411': 'Perg',
  'AT.412': 'Ried im Innkreis',
  'AT.413': 'Rohrbach',
  'AT.414': 'Schärding',
  'AT.415': 'Steyr-Land',
  'AT.416': 'Urfahr-Umgebung',
  'AT.417': 'Vöcklabruck',
  'AT.418': 'Wels-Land',
  'AT.501': 'Salzburg',
  'AT.502': 'Hallein',
  'AT.503': 'Salzburg-Umgebung',
  'AT.504': 'St. Johann im Pongau',
  'AT.505': 'Tamsweg',
  'AT.506': 'Zell am See',
  'AT.601': 'Graz(Stadt)',
  'AT.603': 'Deutschlandsberg',
  'AT.606': 'Graz-Umgebung',
  'AT.610': 'Leibnitz',
  'AT.611': 'Leoben',
  'AT.612': 'Liezen',
  'AT.614': 'Murau',
  'AT.616': 'Voitsberg',
  'AT.617': 'Weiz',
  'AT.620': 'Murtal',
  'AT.621': 'Bruck-Mürzzuschlag',
  'AT.622': 'Hartberg-Fürstenfeld',
  'AT.623': 'Südoststeiermark',
  'AT.701': 'Innsbruck-Stadt',
  'AT.702': 'Imst',
  'AT.703': 'Innsbruck-Land',
  'AT.704': 'Kitzbühel',
  'AT.705': 'Kufstein',
  'AT.706': 'Landeck',
  'AT.707': 'Lienz',
  'AT.708': 'Reutte',
  'AT.709': 'Schwaz',
  'AT.801': 'Bludenz',
  'AT.802': 'Bregenz',
  'AT.803': 'Dornbirn',
  'AT.804': 'Feldkirch',
  'AT.901': 'Wien 1.,Innere Stadt',
  'AT.902': 'Wien 2.,Leopoldstadt',
  'AT.903': 'Wien 3.,Landstraße',
  'AT.904': 'Wien 4.,Wieden',
  'AT.905': 'Wien 5.,Margareten',
  'AT.906': 'Wien 6.,Mariahilf',
  'AT.907': 'Wien 7.,Neubau',
  'AT.908': 'Wien 8.,Josefstadt',
  'AT.909': 'Wien 9.,Alsergrund',
  'AT.910': 'Wien 10.,Favoriten',
  'AT.911': 'Wien 11.,Simmering',
  'AT.912': 'Wien 12.,Meidling',
  'AT.913': 'Wien 13.,Hietzing',
  'AT.914': 'Wien 14.,Penzing',
  'AT.915': 'Wien 15.,Rudolfsheim-Fünfhaus',
  'AT.916': 'Wien 16.,Ottakring',
  'AT.917': 'Wien 17.,Hernals',
  'AT.918': 'Wien 18.,Währing',
  'AT.919': 'Wien 19.,Döbling',
  'AT.920': 'Wien 20.,Brigittenau',
  'AT.921': 'Wien 21.,Floridsdorf',
  'AT.922': 'Wien 22.,Donaustadt',
  'AT.923': 'Wien 23.,Liesing',
};
